import React, { useState } from "react";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export const NewsletterBox = () => {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) { toast.error("Inserisci la tua email"); return; }
    setSending(true);
    try {
      await api.post("/newsletter/subscribe", { email });
      setDone(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Errore nell'iscrizione. Riprova.");
    } finally {
      setSending(false);
    }
  };

  if (done) return (
    <div className="mt-14 rounded-lg bg-[#1a4a8a] p-8 text-center" data-testid="newsletter-success">
      <Mail size={26} className="mx-auto text-white" strokeWidth={1.5}/>
      <h3 className="font-serif text-2xl text-white mt-3">Iscrizione confermata</h3>
      <p className="text-white/80 text-sm mt-2">Ti avviseremo via email quando pubblicheremo un nuovo articolo.</p>
    </div>
  );

  return (
    <div className="mt-14 rounded-lg bg-[#1a4a8a] p-8" data-testid="newsletter-box">
      <div className="max-w-xl mx-auto text-center">
        <h3 className="font-serif text-2xl md:text-3xl text-white flex items-center justify-center gap-2">
          <Mail size={24} strokeWidth={1.5}/> Non perderti i nuovi articoli
        </h3>
        <p className="text-white/80 text-sm mt-3">Lascia la tua email: ti avviseremo quando pubblicheremo una nuova guida su debiti, saldo e stralcio e come difenderti.</p>
        <form onSubmit={submit} className="mt-6 flex flex-col sm:flex-row gap-3">
          <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required
            placeholder="La tua email" data-testid="newsletter-email"
            className="flex-1 rounded-lg px-4 py-3 text-sm bg-white text-[#333333] focus:outline-none"/>
          <button type="submit" disabled={sending} data-testid="newsletter-submit"
            className="btn-cta px-6 py-3 rounded-lg text-sm tracking-wide disabled:opacity-60 whitespace-nowrap">
            {sending ? "Invio…" : "Avvisami"}
          </button>
        </form>
        <p className="text-[11px] text-white/50 mt-3">Niente spam: solo i nuovi articoli. Puoi annullare l'iscrizione in ogni momento.</p>
      </div>
    </div>
  );
};
